<template>
  <div
  @click="logDynamicData"
      :id="props.id || `product-banner-${random_id}`"
      class="relative max-w-max">
    <TsImage
        v-if="props.backgroundImage && props.backgroundImage.url"
        :src="props.backgroundImage.url"
        :width="props.backgroundImage.width"
        :height="props.backgroundImage.height"
        loading="lazy"
    />

    <div class="absolute left-0 bottom-0 p-4 w-full">
      <TsMedia>
        <TsMediaContent append-class="flex">
          <div class="mt-auto">
            <TsTypography
                v-if="props.title"
                :variant="isMobile ? 'h2' : 'h1'"
                append-class="mb-0 text-white"
                align="left"
                style="text-shadow: 0 0 3px #000, 0 0 5px #0000FF;"
            >
              {{ props.title }}
            </TsTypography>
            <TsTypography
                v-if="props.description"
                append-class="text-white"
                weight="semibold"
                align="left"
                :size="isMobile ? 'sm': 'base'"
                style="text-shadow: 0 0 3px #000, 0 0 5px #0000FF;"
            >
              {{ props.description }}
            </TsTypography>
          </div>
        </TsMediaContent>
        <TsMediaEnd append-class="max-w-[130px]">
          <div class="pb-0 overflow-hidden mb-2">
            <div v-if="product_data" class="relative -bottom-8 z-0 p-2 md:p-4 bg-[#FFE000] rounded-2xl md:pb-9">
              <TsTypography
                  v-if="product_data"
                  append-class="text-idle-black"
                  weight="semibold"
                  align="center"
              >
                {{ product_price }} <br />
                <span class="text-sm">{{rootStore.isIncVat ? 'Incl.' : 'Excl.'}} {{useTranslation('vat' ,'btw')}}</span>
              </TsTypography>
            </div>

            <div
                v-if="props.offer || props.offerType"
                class="relative p-2 md:p-4 bg-[#DC0D15] rounded-2xl z-10"
            >
              <TsTypography
                  v-if="props.offer"
                  append-class="text-idle-white font-bold mb-0 leading-none text-4xl"
                  align="center"
              >
                {{ props.offer }}
              </TsTypography>
              <TsTypography
                  v-if="props.offerType"
                  append-class="text-idle-white font-bold mb-0 leading-none"
                  variant="h2"
                  align="center">
                {{ props.offerType }}
              </TsTypography>
            </div>
          </div>

          <TsButton
              v-if="props.buttonLabel"
              :label="props.buttonLabel"
              size="sm"
              append-class="font-bold text-lg text-idle-black px-4 py-1 bg-[#FFE000] border-[#FFE000] hover:bg-[#FFE000]"
          />
        </TsMediaEnd>
      </TsMedia>
    </div>
  </div>
</template>

<script setup lang="ts">
import {useTranslation} from "~/composables/useTranslation";

const rootStore = useRootStore();
const {isMobile} = useDevice();

type Image = {
  url?: string;
  width?: string;
  height?: string;
}

type Props = {
  id?: string;
  backgroundImage?: Image;
  buttonLabel?: string;
  offer?: string;
  offerType?: string;
  packSize?: string;
  productId?: string;
  title?: string;
  description?: string;
}

const props = withDefaults(defineProps<Props>(), {
  backgroundImage: () => ({
    url: '/images/product-banner.jpg',
    width: '600',
    height: '400'
  }),
  buttonLabel: 'Shop now',
  offer: '2+1',
  offerType: 'GRATIS',
  packSize: '3 stucks',
  productId: '29688',
  title: 'FM310 MULTI FOAM PRO',
  description: 'pistoolschuim 750ml'
})

const TsMediaContent = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaContent.vue')
);

const TsMediaEnd = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaEnd.vue')
);


const getProductData = async (id: string) => {
  const data = await useAjaxEcom(
      '/products/getProducts',
      {
        method: 'post',
        params: {
          "products": [id]
        }
      }
  );

 return data?.data[0];
}

const product_id = computed(() => props.productId);

const product_data = ref();

const product_price = computed(() => {
  return rootStore.isIncVat ? product_data.value?.prices?.formatted?.gross : product_data.value?.prices?.formatted?.net;
})

const random_id = ref("");
onMounted(async () => {
  random_id.value = useRandomUUID();
  product_data.value = await getProductData(product_id.value);
  bannerView(product_data?.value, "product banner");
});

const stopBannerProductCodeWatcher = watch(product_id, async () => {
  product_data.value = await getProductData(product_id.value)
})
// GTM Log FOR banner click
const logDynamicData = () => {
  bannerClick(product_data?.value, "product banner");
};

onUnmounted(() => {
  stopBannerProductCodeWatcher();
})
</script>